'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _defineProperty = require('@babel/runtime/helpers/defineProperty');

var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');

var _createClass = require('@babel/runtime/helpers/createClass');

var Cookies = require('js-cookie');

var setup = require('pobble-components/dist/setup');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _defineProperty__default =
/*#__PURE__*/
_interopDefaultLegacy(_defineProperty);

var _classCallCheck__default =
/*#__PURE__*/
_interopDefaultLegacy(_classCallCheck);

var _createClass__default =
/*#__PURE__*/
_interopDefaultLegacy(_createClass);

var Cookies__default =
/*#__PURE__*/
_interopDefaultLegacy(Cookies);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/**
 * This component allows communication between different SPAs
 * We set a cookie in one SPA, then receive it in another
 */


var PobbleCookie =
/*#__PURE__*/
function () {
  function PobbleCookie(cookieName) {
    _classCallCheck__default["default"](this, PobbleCookie);

    this.name = cookieName;
  }

  _createClass__default["default"](PobbleCookie, [{
    key: "set",
    value: function set(value, settings) {
      return Cookies__default["default"].set(this.name, value, _objectSpread(_objectSpread({}, setup.COOKIE_SETTINGS), settings));
    }
  }, {
    key: "get",
    value: function get() {
      return Cookies__default["default"].get(this.name, setup.COOKIE_SETTINGS);
    }
  }, {
    key: "remove",
    value: function remove() {
      return Cookies__default["default"].remove(this.name, setup.COOKIE_SETTINGS);
    }
  }, {
    key: "pull",
    value: function pull() {
      var cookie = this.get();
      this.remove();
      return cookie;
    }
  }]);

  return PobbleCookie;
}();
/**
 * Set to true to show last slide on the builder
 *   next time user gets there
 */


var LP_SHOW_LAST_SLIDE = new PobbleCookie('LP_SHOW_LAST_SLIDE');
/**
 * Specify the active builder slide
 *  for the next time user gets there
 */

var BUILDER_ACTIVE_SLIDE_ID = new PobbleCookie('BUILDER_ACTIVE_SLIDE_ID');
/**
 * Notify that jwt token has expired
 */

var JWT_EXPIRED = new PobbleCookie('JWT_EXPIRED');
/**
 * Specify a redirect after authentication
 */

var AUTH_REDIRECT = new PobbleCookie('AUTH_REDIRECT');
/**
 * Identify user's first ever session on the platfform
 */

var FIRST_SESSION = new PobbleCookie('FIRST_SESSION');
exports.AUTH_REDIRECT = AUTH_REDIRECT;
exports.BUILDER_ACTIVE_SLIDE_ID = BUILDER_ACTIVE_SLIDE_ID;
exports.FIRST_SESSION = FIRST_SESSION;
exports.JWT_EXPIRED = JWT_EXPIRED;
exports.LP_SHOW_LAST_SLIDE = LP_SHOW_LAST_SLIDE;
exports.PobbleCookie = PobbleCookie;